import React, { useCallback, useContext, useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DynamicTable from "../../components/tables/dynamic-table1";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import { productDeleteAction } from "../../redux/actions/product-action";
import { storeTableAction } from "../../redux/actions/store-action";
import StoreFilter from "../../components/tables/table-filter/store-filter";
import { DataContext } from "../../components/layouts/main-layout";

const StoreExecutionTable = () => {
  const { permissionFn } = useContext(DataContext);
  const dispatch = useDispatch();
  const [storeList, setStoreList] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [reload, setReload] = useState(false);
    const [pageSize, setPageSize] = useState(10);;
  const [tableHeading, setTableHeading] = useState(tabHeading);
  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    selectColumn: "",
  });

  useEffect(() => {
    dispatch(
      storeTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
  }, [currentPage, pageSize, filterData, reload]);
  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setStoreList(data?.data?.storeList);
    setDataCount(data?.data?.totalCount);
  };
  const onError = (data) => {
    setError(true);
    setLoading(false);
  };

  const navigate = useNavigate();

  const filteredTableHeading = tableHeading.filter(
    (item) => item.isColumnneeded
  );

  const tableBodyData = storeList?.map((item) => {
    const rowData = {
      id: item?.store_id,
    };
    filteredTableHeading.forEach((column) => {
      if (column?.value != "action") {
        if (column.value === "authorised_person_name") {
          rowData.authorised_person_name =
            // (
            // <a href={`/view-store/${item?.store_id}`} className="fw_500">
            item?.authorised_person_name ?? "--";
          {
            /* </a> */
          }
          // ) ?? "--";
        } else {
          rowData[column.value] = item[column.value] ?? "--";
        }
      }
    });
    return rowData;
  });
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };
  const handleFilterClick = useCallback(() => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
  }, []);

  const filterby = showFilter ? (
    <StoreFilter
      setTableHeading={setTableHeading}
      tableHeading={tableHeading}
      filterData={filterData}
      setFilterData={setFilterData}
      setShowFilter={setShowFilter}
    />
  ) : null;

  return (
    <InnerLayout
      permissionFn={permissionFn}
      module="store_information"
      list={true}
      onclkFn={() => navigate("/add-store")}
      title="Store Execution"
    >
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <DynamicTable
          is_checkbox_req={false}
          onClickItemFn={(id) => navigate(`/view-store-execution/${id}`)}
          list={false}
          menu={true}
          permissionFn={permissionFn}
          module={"store_execution_process"}
          date={false}
          path="store-execution"
          id_name="store_id"
          reload={reload}ś
          setReload={setReload}
          loading={loading}
          setLoading={setLoading}
          deleteAction={productDeleteAction}
          label="Store"
          showFilter={showFilter}
          filterFn={handleFilterClick}
          setFilterData={setFilterData}
          filterData={filterData}
          paginationProps={paginationProps}
          tableHeading={filteredTableHeading}
          tableBodyData={tableBodyData}
          placeholder="Search"
          filterBy={filterby}
          filterText="Show or Hide Columns"
          initialFilter={{
            sort_by: "",
            sort_order: "",
            selectColumn: "",
            from: "",
            to: "",
            itemgroup: [],
          }}
        />
      )}
    </InnerLayout>
  );
};

export default StoreExecutionTable;
const tabHeading = [
  {
    label: "Store Code",
    value: "store_code",
    display: true,
    column: true,
    isColumnneeded: true, // New key
  },
  {
    label: "Store Name",
    value: "store_name",
    display: true,
    column: true,
    isColumnneeded: true, // New key
  },
  {
    label: "Contact Person",
    value: "authorised_person_name",
    display: true,
    column: true,
    isColumnneeded: true, // New key
  },
  {
    label: "Mobile Number",
    value: "phone_number",
    display: true,
    column: true,
    isColumnneeded: true, // New key
  },
  {
    label: "Firm Name",
    value: "firm_name",
    display: true,
    column: true,
    isColumnneeded: true, // New key
  },
  {
    label: "Store type",
    value: "store_type",
    display: false,
    column: false,
    isColumnneeded: true, // New key
  },
  {
    label: "Area",
    value: "shop_area",
    display: true,
    column: false,
    isColumnneeded: false, // New key
  },
  {
    label: "City",
    value: "shop_city",
    display: true,
    column: false,
    isColumnneeded: false, // New key
  },
  {
    label: "State",
    value: "shop_state",
    display: true,
    column: false,
    isColumnneeded: false, // New key
  },
  {
    label: "Status",
    value: "store_status",
    display: true,
    column: false,
    isColumnneeded: true, // New key
  },
  {
    label: "Request Received On",
    value: "created_date",
    display: true,
    column: false,
    isColumnneeded: false, // New key
  },
  {
    label: "Payment Receive On",
    value: "payment_recevie_time",
    display: true,
    column: false,
    isColumnneeded: false, // New key
  },
  {
    label: "RM Name",
    value: "relationship_manager",
    display: true,
    column: false,
    isColumnneeded: true, // New key
  },
  {
    label: "",
    value: "",
    column: false,
    isColumnneeded: true, // New key
  },
  {
    label: "",
    value: "",
    column: false,
    isColumnneeded: true, // New key
  },
];
